<template>
    <article class="scenePresentation" :style="[getPosition, getHeight]" :class="state">
        <button class="btntoggle" @click="toggle()">
            <IconChevron></IconChevron>
        </button>
        <h3 ref="header">{{ properties.title }}</h3>
        <div ref="brief" class="scenePresentation__briefcontent" :class="{ visible: state == 'brief' }">
            <span v-html="properties.brief"></span>
            <button class="btnfull" @click="showFull()"><span></span>Learn More</button>
        </div>
        <div ref="full" class="scenePresentation__fullcontent" :class="{ visible: state == 'full' }"
            v-html="properties.text"></div>
    </article>
</template>

<script>
export default {
    props: ["properties", "pageData"],
    data() {
        return {
            state: "closed",
            briefHeight: 0,
            fullHeight: 0,

        }
    },
    mounted() {
        this.briefHeight = this.$refs.brief.clientHeight;
        this.fullHeight = this.$refs.full.clientHeight;
    },
    computed: {
        getPosition() {

            var negativeMargin = parseInt(this.$store.getters.getMaximizedSizeAndOffsetValue.left);
            var xPosition = 180;

            return {
                right: (xPosition + negativeMargin) + 'px',
            }
        },
        getHeight() {
            switch (this.state) {
                case "closed":
                    return ""

                case "brief":
                    return { height: this.briefHeight +80+ "px" }

                case "full":
                    return { height: this.fullHeight + 150 + "px" }

            }
        }
    },
    methods: {
        toggle() {
            this.state = (this.state == 'closed') ? 'brief' : 'closed'
        },
        showFull() {
            this.state = 'full';
        }
    }
};
</script>

<style lang="scss">
.scenePresentation {
    position: absolute;
    bottom: 75px;
    background: var(--main-color-trans);
    width: 340px;
    height: 50px;
    color: #fff;
    border-radius: 25px;
    transition: height .2s, width .2s;
    text-align: left;
    font-size: 18px;
    font-weight:400;
 


    // hidden toggle button

    .btntoggle {
        width: 100%;
        height: 50px;
        position: absolute;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        padding-right: 20px;

        svg {
            transform: rotate(-180deg);
            transition: transform .5s;
        }
    }


    // states

    &.brief,
    &.full {
        .btntoggle svg {
            transform: rotate(0deg);
        }
    }

    &.brief {
        width: 340px;

        h3 {
            margin-top: 28px;
        }
    }

    &.full {
        width: 890px;

        h3 {
            margin: 28px 40px;
            font-size: 40px;
        }
    }


    // content

    h3 {
        font-size: 22px;
        font-weight: bold;
        width: 320px;
        // padding: 0 28px;
        margin: 10px 28px;
        pointer-events: none;
        transition: margin .1s;
    }

    &__briefcontent,
    &__fullcontent {
        position: absolute;
        pointer-events: none;
        opacity: 0;
        transition: none;

        &.visible {
            transition: opacity 0.5s .1s;
            opacity: 1;
            pointer-events: all;
        }
    }

    &__briefcontent {
        width: 322px;
        padding: 0px 28px;

        .btnfull {
            margin: 20px 0;
            display: flex;
            align-items: center;
           span {
            width: 40px;
            height:40px;
            display: flex;
            background-color: var(--secondary-color);
            background-image: url(@/assets/img/ui/plus.png);
            background-repeat: no-repeat;
            border-radius: 50%;
            background-position: center;
            margin-right:10px;
               line-height: 1.4em;;
           }
        }

    }

    &__fullcontent {
        width: 880px;
        padding: 0 40px;
        font-size: 20px;
        max-height: 600px;
        overflow: auto;
    }

}
</style>